// import React, { useState } from "react";
// import classes from "./Counter.module.scss";

// const Counter = ({ product, addProductToCart, updateQuantity }) => {
//   const [quantity, setQuantity] = useState(1);

//   const increment = () => setQuantity(quantity + 1);
//   const decrement = () => setQuantity(quantity - 1 > 0 ? quantity - 1 : 1);

//   const addProduct = () => {
//     addProductToCart(product, quantity);
//     updateQuantity(quantity);
//   };

//   return (
//     <section className={classes.counter}>
//       <div className={classes.counter_container}>
//         <span className={classes.increment} onClick={increment}>
//           +
//         </span>
//         <span className={classes.value}>{quantity}</span>
//         <span className={classes.decrement} onClick={decrement}>
//           -
//         </span>
//       </div>
//       <button className={classes.addToCart} onClick={addProduct}>
//         Add To Cart
//       </button>
//     </section>
//   );
// };

// export default Counter;

// import React, { useState } from "react";
// import classes from "./Counter.module.scss";
// import { useContext } from "react";
// import { CartContext } from "../../../store/shopping-cart-context";

// const Counter = ({
//   product,
//   addProductToCart,
//   updateQuantity,
//   // increment,
//   // decrement,
//   quantity,
// }) => {
//   const cartCtx = useContext(CartContext);
//   const increment = () => {
//     cartCtx.incrementItem();
//   };
//   const decrement = () => {
//     cartCtx.decrementItem();
//   };
//   const addProduct = () => {
//     addProductToCart(product, quantity);
//     updateQuantity(quantity);
//   };

//   return (
//     <section className={classes.counter}>
//       <div className={classes.counter_container}>
//         <span className={classes.increment} onClick={increment}>
//           +
//         </span>
//         <span className={classes.value}>{quantity}</span>
//         <span className={classes.decrement} onClick={decrement}>
//           -
//         </span>
//       </div>
//       <button className={classes.addToCart} onClick={addProduct}>
//         Add To Cart
//       </button>
//     </section>
//   );
// };

// export default Counter;

import React, { useContext, useState } from "react";
import classes from "./Counter.module.scss";
import { CartContext } from "../../../store/shopping-cart-context";
import productList from "../../CartCheckOut/productData";

const Counter = ({
  product,
  addProductToCart,
  updateQuantity,
  initialQuantity,
}) => {
  const [quantity, setQuantity] = useState(initialQuantity || 1);
  const increment = () => setQuantity((prevQuantity) => prevQuantity + 1);
  const decrement = () =>
    setQuantity((prevQuantity) =>
      prevQuantity - 1 > 0 ? prevQuantity - 1 : 1
    );

  const cartCtx = useContext(CartContext);
  const addProduct = () => {
    addProductToCart(product, quantity);
    updateQuantity(quantity);
  };

  return (
    <section className={classes.counter}>
      <div className={classes.counter_container}>
        <span className={classes.increment} onClick={increment}>
          +
        </span>
        <span className={classes.value}>{quantity}</span>
        <span className={classes.decrement} onClick={decrement}>
          -
        </span>
      </div>
      <button className={classes.addToCart} onClick={addProduct}>
        Add To Cart
      </button>
    </section>
  );
};

export default Counter;
